/* Witter Gebit: local initialization of the existing storefront features. */
(() => {
  'use strict';
  if (window.wgLocalFeatures) return;

  const config = document.getElementById('wg-local-features-config');
  if (!config) return;
  let features;
  try {
    features = JSON.parse(config.textContent).filter(feature => feature.enabled);
  } catch (error) {
    console.error('[WG] Local feature configuration could not be read.', error);
    return;
  }

  const loaded = new Map();
  const state = { loaded: [], failed: [] };
  window.wgLocalFeatures = state;

  function load(feature) {
    if (loaded.has(feature.name)) return loaded.get(feature.name);
    const src = new URL(feature.src, location.href);
    if (src.origin !== location.origin && src.hostname !== 'cdn.shopify.com') {
      console.error('[WG] Unexpected feature asset origin.', feature.name);
      return;
    }
    if ([...document.scripts].some(script => script.src === src.href)) {
      loaded.set(feature.name, Promise.resolve());
      state.loaded.push(feature.name);
      return loaded.get(feature.name);
    }

    const promise = new Promise(resolve => {
      const script = document.createElement('script');
      script.src = src.href;
      script.async = true;
      script.dataset.wgFeature = feature.name;
      script.addEventListener('load', () => {
        state.loaded.push(feature.name);
        resolve();
      }, { once: true });
      script.addEventListener('error', () => {
        state.failed.push(feature.name);
        console.error('[WG] A local feature could not load.', feature.name);
        resolve();
      }, { once: true });
      document.head.appendChild(script);
    });
    loaded.set(feature.name, promise);
    return promise;
  }

  function loadGroup(group) {
    features.filter(feature => feature.when === group).forEach(load);
  }

  function loadPresentFeatures() {
    if (document.body.classList.contains('template-product') || document.querySelector('.product.section')) loadGroup('product');
    if (document.querySelector('.product-item')) loadGroup('product-grid');
    if (document.body.classList.contains('template-collection')) loadGroup('collection');
    if (document.body.classList.contains('template-cart')) loadGroup('cart');
  }

  function start() {
    if (!window.theme?.helpers) return;
    loadGroup('immediate');
    loadPresentFeatures();
    document.addEventListener('theme:cart:loading', () => loadGroup('cart'));
    document.addEventListener('theme:cart:loaded', () => loadGroup('cart'));
    document.addEventListener('shopify:section:load', loadPresentFeatures);
    document.addEventListener('theme:section:product-recommendations:loaded', loadPresentFeatures);
    document.addEventListener('theme:addon:infinite-scroll:loaded', loadPresentFeatures);
  }

  // A deferred script may execute while the earlier module is still loading.
  // DOMContentLoaded waits for both; do not start from readyState=interactive.
  if (document.readyState !== 'complete') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(start, 0), { once: true });
  } else {
    setTimeout(start, 0);
  }
})();
